import React from "react";

interface ITag {
  text: string;
}

const Tag = ({ text }: ITag) => {
  return (
    <span className="p-1 border-complementary uppercase font-bold text-xs bg-complementary/50 text-complementary rounded">
      {text}
    </span>
  );
};

export default Tag;
